import PageStatisticTest from './pageStatisticTest';
export default PageStatisticTest;
